import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "whatsapp-chat",
  id: "whatsapp-chat"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "whatsapp-chat-toggler",
  class: "whatsapp-chat-toggler"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "whatsapp-chat-toggler",
  class: "whatsapp-chat-backdrop"
}, null, -1)
const _hoisted_4 = { class: "whatsapp-chat-window" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"whatsapp-chat-header\"><img src=\"https://i.imgur.com/G43yQHs.png\" class=\"whatsapp-chat-contact-img\"><div class=\"whatsapp-chat-contact-info\"><strong>Linkedbux</strong><small> Customer service • <span class=\"text-wa-light-green\">Online</span></small></div><label for=\"whatsapp-chat-toggler\" title=\"WhatsApp\" class=\"whatsapp-chat-close\"><svg width=\"55\" height=\"55\" viewBox=\"0 0 55 55\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M42.5467 12.4536C43.2627 13.1696 43.2627 14.3304 42.5467 15.0464L15.0467 42.5464C14.3307 43.2623 13.1699 43.2623 12.454 42.5464C11.738 41.8304 11.738 40.6696 12.454 39.9536L39.954 12.4536C40.6699 11.7377 41.8307 11.7377 42.5467 12.4536Z\" fill=\"currentColor\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.454 12.4536C13.1699 11.7377 14.3307 11.7377 15.0467 12.4536L42.5467 39.9536C43.2627 40.6696 43.2627 41.8304 42.5467 42.5464C41.8307 43.2623 40.6699 43.2623 39.954 42.5464L12.454 15.0464C11.738 14.3304 11.738 13.1696 12.454 12.4536Z\" fill=\"currentColor\"></path></svg></label></div>", 1)
const _hoisted_6 = { class: "whatsapp-chat-body" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "whatsapp-chat-bubble" }, [
  /*#__PURE__*/_createTextVNode(" Hello, welcome. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Please provide your details and we will respond as soon as possible! ")
], -1)
const _hoisted_8 = {
  for: "whatsapp-name",
  class: "whatsapp-chat-green-bubble"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "error-text" }, " This field is required ")
], -1)
const _hoisted_10 = {
  for: "whatsapp-email",
  class: "whatsapp-chat-green-bubble"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "error-text" }, " This field is required ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "whatsapp-chat-btn"
}, " Send message ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "whatsapp-chat-toggler",
  class: "whatsapp-chat-button"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20.4054 3.4875C18.1607 1.2375 15.1714 0 11.9946 0C5.4375 0 0.101786 5.33571 0.101786 11.8929C0.101786 13.9875 0.648214 16.0339 1.6875 17.8393L0 24L6.30536 22.3446C8.04107 23.2929 9.99643 23.7911 11.9893 23.7911H11.9946C18.5464 23.7911 24 18.4554 24 11.8982C24 8.72143 22.65 5.7375 20.4054 3.4875ZM11.9946 21.7875C10.2161 21.7875 8.475 21.3107 6.95893 20.4107L6.6 20.1964L2.86071 21.1768L3.85714 17.5286L3.62143 17.1536C2.63036 15.5786 2.11071 13.7625 2.11071 11.8929C2.11071 6.44464 6.54643 2.00893 12 2.00893C14.6411 2.00893 17.1214 3.0375 18.9857 4.90714C20.85 6.77679 21.9964 9.25714 21.9911 11.8982C21.9911 17.3518 17.4429 21.7875 11.9946 21.7875ZM17.4161 14.3839C17.1214 14.2339 15.6589 13.5161 15.3857 13.4196C15.1125 13.3179 14.9143 13.2696 14.7161 13.5696C14.5179 13.8696 13.95 14.5339 13.7732 14.7375C13.6018 14.9357 13.425 14.9625 13.1304 14.8125C11.3839 13.9393 10.2375 13.2536 9.08571 11.2768C8.78036 10.7518 9.39107 10.7893 9.95893 9.65357C10.0554 9.45536 10.0071 9.28393 9.93214 9.13393C9.85714 8.98393 9.2625 7.52143 9.01607 6.92679C8.775 6.34821 8.52857 6.42857 8.34643 6.41786C8.175 6.40714 7.97679 6.40714 7.77857 6.40714C7.58036 6.40714 7.25893 6.48214 6.98571 6.77679C6.7125 7.07679 5.94643 7.79464 5.94643 9.25714C5.94643 10.7196 7.0125 12.1339 7.15714 12.3321C7.30714 12.5304 9.25179 15.5304 12.2357 16.8214C14.1214 17.6357 14.8607 17.7054 15.8036 17.5661C16.3768 17.4804 17.5607 16.8482 17.8071 16.1518C18.0536 15.4554 18.0536 14.8607 17.9786 14.7375C17.9089 14.6036 17.7107 14.5286 17.4161 14.3839Z",
      fill: "currentColor"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_NotificationsList = _resolveComponent("NotificationsList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_router_view),
    _createVNode(_component_NotificationsList),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.send()), ["prevent"]))
          }, [
            _createElementVNode("label", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "whatsapp-name",
                placeholder: "Your name",
                required: "",
                class: "whatsapp-chat-input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.obj.name) = $event))
              }, null, 512), [
                [_vModelText, $setup.obj.name]
              ]),
              _hoisted_9
            ]),
            _createElementVNode("label", _hoisted_10, [
              _withDirectives(_createElementVNode("textarea", {
                type: "text",
                id: "whatsapp-email",
                placeholder: "Your message",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.obj.email) = $event)),
                required: "",
                class: "whatsapp-chat-input"
              }, null, 512), [
                [_vModelText, $setup.obj.email]
              ]),
              _hoisted_11
            ]),
            _hoisted_12
          ], 32)
        ])
      ]),
      _hoisted_13
    ])
  ]))
}